import React, { useState } from 'react';
import { Search } from 'lucide-react';
import { Input, StatusBadge } from '../../ui';

const AUDIT_LOG = [
  { id: 1,  ts: '2026-03-17 09:14',  actor: 'cwei@nexonurse.com',    action: 'Tenant Created',      target: 'Coastal Medical',         details: 'New tenant onboarded — Growth tier' },
  { id: 2,  ts: '2026-03-17 09:18',  actor: 'cwei@nexonurse.com',    action: 'User Invited',        target: 'jlee@coastalmed.com',     details: 'Role: Unit Manager' },
  { id: 3,  ts: '2026-03-16 14:02',  actor: 'admin@nexonurse.com',   action: 'Feature Toggled',     target: 'Summit Care',             details: 'emailSignal: false → true' },
  { id: 4,  ts: '2026-03-16 11:45',  actor: 'cwei@nexonurse.com',    action: 'User Deactivated',    target: 'anoor@valleyhospital.com', details: 'Reason: account closure' },
  { id: 5,  ts: '2026-03-15 16:30',  actor: 'admin@nexonurse.com',   action: 'Role Changed',        target: 'dpatel@summitcare.com',   details: 'Unit Manager → Service Line Director' },
  { id: 6,  ts: '2026-03-15 10:00',  actor: 'admin@nexonurse.com',   action: 'Feature Toggled',     target: 'Riverside Health',        details: 'strategicInitiatives: false → true' },
  { id: 7,  ts: '2026-03-14 08:55',  actor: 'cwei@nexonurse.com',    action: 'Tenant Created',      target: 'Summit Care',             details: 'New tenant onboarded — Starter tier' },
  { id: 8,  ts: '2026-03-13 15:22',  actor: 'cwei@nexonurse.com',    action: 'MFA Reset',           target: 'mgonzalez@riverside.com', details: 'Reset triggered by admin' },
  { id: 9,  ts: '2026-03-12 11:10',  actor: 'admin@nexonurse.com',   action: 'User Invited',        target: 'skim@summitcare.com',     details: 'Role: Unit Manager' },
  { id: 10, ts: '2026-03-11 09:00',  actor: 'cwei@nexonurse.com',    action: 'Tenant Created',      target: 'Riverside Health',        details: 'New tenant onboarded — Enterprise tier' },
  { id: 11, ts: '2026-03-10 14:40',  actor: 'admin@nexonurse.com',   action: 'Feature Toggled',     target: 'Valley Hospital',         details: 'assignments: true → false' },
  { id: 12, ts: '2026-03-09 10:15',  actor: 'cwei@nexonurse.com',    action: 'Role Changed',        target: 'jokafor@riverside.com',   details: 'Unit Manager → Service Line Director' },
];

const ACTION_BADGE_VARIANT = {
  'Tenant Created':   'info',
  'User Invited':     'info',
  'User Deactivated': 'critical',
  'Feature Toggled':  'watch',
  'Role Changed':     'info',
  'MFA Reset':        'on-track',
};

const ACTION_TYPES = [...new Set(AUDIT_LOG.map(e => e.action))];

export default function AuditLogPage() {
  const [search, setSearch] = useState('');
  const [filterAction, setFilterAction] = useState('');

  const filtered = AUDIT_LOG.filter(e => {
    const q = search.toLowerCase();
    const matchQ = !q || e.actor.toLowerCase().includes(q) || e.target.toLowerCase().includes(q) || e.details.toLowerCase().includes(q);
    const matchA = !filterAction || e.action === filterAction;
    return matchQ && matchA;
  });

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1 className="dashboard-title">Audit Log</h1>
        <p className="dashboard-subtitle">Admin activity trail across all tenants.</p>
      </div>

      <div className="flex flex-wrap gap-3 mb-4 items-center">
        <div style={{ position: 'relative', flex: 1 }}>
          <Search size={14} style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)' }} />
          <Input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search actor, target, or details…"
            style={{ width: '100%', paddingLeft: 30, boxSizing: 'border-box' }} />
        </div>
        <select value={filterAction} onChange={e => setFilterAction(e.target.value)} className="w-full h-9 rounded-lg border border-nn-border bg-nn-white px-3 text-[13px] text-text-dark focus:outline-none focus:ring-2 focus:ring-aqua/30">
          <option value="">All Actions</option>
          {ACTION_TYPES.map(a => <option key={a} value={a}>{a}</option>)}
        </select>
      </div>

      <div className="bg-nn-white rounded-card-lg shadow-card overflow-hidden relative">
        <div style={{ padding: 0, overflow: 'hidden' }}>
          <table className="nn-table">
            <thead>
              <tr>
                {['Timestamp', 'Actor', 'Action', 'Target', 'Details'].map(h => (
                  <th key={h}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map(e => (
                <tr key={e.id}>
                  <td className="text-text-dark-secondary" style={{ fontSize: 12, whiteSpace: 'nowrap' }}>{e.ts}</td>
                  <td className="text-text-dark-secondary">{e.actor}</td>
                  <td>
                    <StatusBadge variant={ACTION_BADGE_VARIANT[e.action] || 'info'}>
                      {e.action}
                    </StatusBadge>
                  </td>
                  <td>{e.target}</td>
                  <td className="text-text-dark-secondary">{e.details}</td>
                </tr>
              ))}
              {filtered.length === 0 && (
                <tr><td colSpan={5} className="text-center text-text-dark-secondary text-[13px]" style={{ padding: 32 }}>No entries match your filters.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="text-text-dark-secondary" style={{ marginTop: 8, fontSize: 12 }}>{filtered.length} of {AUDIT_LOG.length} entries</div>
    </div>
  );
}
